import { defer } from 'react-router-dom'

import { isAppStateReady } from '$appStore'
import { logger } from '$utils'

import { getInvoices } from './api'

/**
 * Loads the invoices the Manage Billing page renders.
 *
 * Only invoices are deferred here - they're fast. The subscription summary is
 * loaded independently in the page via React Query because `/subscriptions` is
 * slow, and blocking the whole page on it caused the perceived "reload" flash.
 */
export default async function loader() {
  await isAppStateReady()

  return defer({
    invoices: getInvoices().catch((error) => {
      logger.error('Failed to load invoices', error)
      throw error
    }),
  })
}
